module.exports = __webpack_public_path__ + "static/media/isset-escudo-tabasco.b82c5802.svg";